export enum SentryMetricKeys {
  NotFoundPage = 'not-found-page',
  Signups = 'signups'
}
